<app-ion-common-header [id]="headerId" (backHeader)="backPage()" (focusHeader)="shownContent()" [title]="titlePage" start="{{startStage}}" end="{{endStage}}"></app-ion-common-header>

<ion-content [attr.aria-hidden]="ariaHidden" [style.visibility]="ariaHidden ? 'hidden' : 'visible'">
  <app-ion-common-label
          class="document-type-label1" labelStyle="display-rg"
          labelDescription="Por que solicitamos esses dados?">
  </app-ion-common-label>

  <div class="text-rg mt-lg">
    <p class="text-space">
      Esse dado faz parte da CVM 617 que entrou em vigor em 1/10/2020 para aparimorar processos 
      de prevenção à lavagem de dinheiro e ao financiamento do terrorismo (PLDFT).
    </p>
    <p class="text-space">
      Com o objetivo de esclarecer os principais pontos a serem cumpridos pelos participantes do 
      mercado e orientar sobre as melhores práticas, as Superintendências de Relações com o Mercado e 
      Intermediários (SMI) e de Relações com Investidores Institucionais (SIN) da Comissão de Valores 
      Mobiliários (CVM) emitem ofício circular com orientações.
    </p>
    <p class="text-space">
      ABORDAGEM BASEADA EM RISCO<br>
      identificar, analisar e compreender os riscos de LDFT dos respectivos clientes, produtos, 
      serviços, canais de distribuição e prestadores de serviços relevantes, para posteriormente 
      segmentá-los minimamente em baixo, médio e alto.
    </p>
    <p class="text-space">
      POLÍTICA CONHEÇA SEU CLIENTE:<br>
      além do processo de identificação e de coleta de dados cadastrais dos clientes, foram determinadas 
      diligências contínuas, a fim de coletar informações suplementares e, em especial, de 
      identificar seus respectivos beneficiários finais.
    </p>
    <p class="text-space">
      CLIENTE E INVESTIDOR:<br>
      a nova norma adaptou o conceito de cliente com a de investidor mantendo o entendimento da 
      Instrução CVM 505 e esclarecendo, para os exclusivos efeitos de PLDFT, o alcance mais limitado 
      (espécie) do conceito de cliente e mais amplo (gênero) do conceito de investidor.
    </p>
    <p class="text-space">
      i) cliente: investidor que mantém relacionamento comercial direto com as pessoas 
      mencionadas no art. 3º da Instrução CVM 617.
    </p>
    <p class="text-space">
      ii) investidor: pessoa natural ou jurídica, fundo ou veículo de investimento coletivo 
      ou o investidor não residente em nome do qual são efetuadas operações com valores mobiliários.
    </p>
    <p class="text-space">
    </p>
    <p class="text-space">
      CONSIDERAÇÃO SOBRE FUNDOS DE INVESTIMENTO:<br>
      o distribuidor será o prestador de serviços que manterá relação comercial direta com o cotista, 
      sendo que é sua responsabilidade a coleta das informações cadastrais, a manutenção do cadastro 
      e a adoção das diligências previstas em sua Política de PLDFT para controlar e monitorar 
      o risco de PLDFT no que tange às suas atividades.
    </p>
    <p class="text-space">
      ATUALIZAÇÃO CADASTRAL:<br>
      a Política de PLDFT precisa necessariamente tratar, dentre outros pontos, da definição dos 
      critérios e periodicidade para atualização dos cadastros dos clientes ativos, de acordo com o 
      art. 11 da Instrução CVM 617, observando o intervalo máximo de cinco anos.
    </p>
    <p class="text-space">
      SISTEMA ALTERNATIVO DE CADASTRO:<br>
      o é facultado a todos os participantes e sua implementação não é mais pendente de autorização da 
      CVM. Porém, deve estar devidamente previsto em sua Política de PLDFT, com as evidências de 
      sua implementação acessíveis à SMI e à SIN, bem como ao autorregulador.
    </p>
    <p class="text-space">
      SOBRE O BLOQUEIO DE CONTAS:<br>
      e um cliente com conta bloqueada opere unicamente para reduzir ou mesmo para “zerar” 
      a sua posição, hipóteses de pedidos de encerramento de conta ou de alienação ou resgate de ativos.
    </p>
    
  </div>
  
</ion-content>
